import React from 'react';
import { useTheme, jsx } from '@emotion/react';
import Style from './style.js';
import '@babel/runtime/helpers/extends';
import '@babel/runtime/helpers/objectWithoutProperties';
import '../../constants/breakpoints/index.js';
import '../../constants/grid/index.js';
import '../../constants/mediaQueries/index.js';
import '../../constants/boxShadows/primary.js';
import '../../constants/boxShadows/secondary.js';
import CheckmarkIcon from '../../icons/icons/checkmarkIcon.js';
import ErrorIcon from '../../icons/icons/errorIcon.js';
import { VerificationMessages } from '../verificationMessages/index.js';

var Field = _ref => {
  var {
    children: inputChild,
    disabled = false,
    hideMessagesIcon = false,
    hintMessage = '',
    label = '',
    labelFor = '',
    messages = {},
    messagesType = 'error'
  } = _ref;
  var theme = useTheme();
  var htmlFor = labelFor || label;
  var messagesKeys = Object.keys(messages);
  var showMessages = messagesKeys.length > 0;
  var MessageIcon = messagesType === 'success' ? jsx(CheckmarkIcon, {
    fill: theme.COLORS.success,
    className: "radiance-field-input-icon"
  }) : jsx(ErrorIcon, {
    fill: theme.COLORS.error,
    className: "radiance-field-input-icon"
  });
  var {
    id
  } = inputChild.props;
  var isInvalid = showMessages && messagesType === 'error';
  return jsx(Style.FieldContainer, null, !!label && jsx(Style.Label, {
    htmlFor: htmlFor,
    disabled: disabled
  }, label), jsx(Style.InputContainer, {
    showMessages: showMessages,
    messagesType: messagesType
  }, hideMessagesIcon || MessageIcon, /*#__PURE__*/React.cloneElement(inputChild, {
    disabled,
    'aria-invalid': isInvalid || undefined
  }), !!hintMessage && jsx(Style.HintItem, null, hintMessage), jsx(VerificationMessages, {
    messages: messages,
    type: messagesType,
    inputId: id
  })));
};
Field.Textarea = Style.Textarea;
Field.Input = Style.Input;

export { Field };
